// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1fYq8","buttons":"PendingPaymentAlert_buttons__1cm_z"};